import {
  Modal,
  ModalProvider,
  PrimaryButton,
  SecondaryButton,
} from '@joor/design-system'
import styled from 'styled-components/macro'

import usePortal from 'hooks/usePortal'

import { MismatchContent } from './components/MismatchContent'

export function UpdateAddressMismatchModal({
  addressType,
  csdAddress,
  editedAddress,
  isSubmitting,
  onUpdateThisOrder,
  onUpdateThisOrderAndAccount,
  onClose,
}: MismatchModalProps) {
  const Portal = usePortal()

  return (
    <Portal>
      <ModalProvider backgroundComponent={StyledBackgroundComponent}>
        <Modal
          title={{
            text: `${addressType} address mismatch`,
            iconName: 'warning',
          }}
          isOpen
          onClose={onClose}
          size="medium"
        >
          <Modal.Content>
            <MismatchContent
              csdAddress={csdAddress}
              editedAddress={editedAddress}
            />
          </Modal.Content>
          <Modal.Actions>
            <ActionsWrapper>
              <SecondaryButton
                onClick={onUpdateThisOrder}
                loading={isSubmitting}
              >
                This order only
              </SecondaryButton>
              <PrimaryButton
                onClick={onUpdateThisOrderAndAccount}
                loading={isSubmitting}
              >
                This order and account
              </PrimaryButton>
            </ActionsWrapper>
          </Modal.Actions>
        </Modal>
      </ModalProvider>
    </Portal>
  )
}

export type ProvidedAddress = {
  companyName?: string | null
  addressFull?: string
  phoneNumber?: string | null
  email?: string | null
}

export type MismatchModalProps = {
  addressType: string
  csdAddress: ProvidedAddress
  editedAddress: ProvidedAddress
  isSubmitting: boolean
  onUpdateThisOrder: () => void
  onUpdateThisOrderAndAccount: () => void
  onClose: () => void
}

const StyledBackgroundComponent = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 99999;
  backdrop-filter: blur(3px);
  background-color: rgba(0, 0, 0, 0);
  align-items: center;
  justify-content: center;
`

const ActionsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  align-items: center;
`
